/**
 * getLensDetails
 *
 * Removes all null values and __typename from the lens object
 */ const getLensDetails = (lens)=>Object.entries(lens).reduce((acc, [name, value])=>{
        if (value !== null && name !== '__typename') {
            acc[name] = value;
        }
        return acc;
    }, {})
;

export { getLensDetails };
//# sourceMappingURL=get-lens-details.js.map
